import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("admin@muhasebe.com");
  const [password, setPassword] = useState("admin123");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Hoş geldiniz");
      nav(u?.role === "admin" ? "/" : "/projeler");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Giriş başarısız");
    } finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2">
      <div className="hidden md:block relative">
        <img
          src="https://images.unsplash.com/photo-1611600700192-d87eaeed4f81?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="wood"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-zinc-900/40" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <h1 className="text-4xl font-semibold tracking-tight">Atölye Muhasebe</h1>
          <p className="text-sm text-zinc-200 mt-2 max-w-md">
            Mobilya imalatçıları için sade ve profesyonel muhasebe deneyimi. Cari takip, fatura, kasa ve analiz — hepsi tek yerde.
          </p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 bg-[--page-bg]">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="login-form">
          <div>
            <div className="text-xs uppercase tracking-widest text-zinc-500">Giriş</div>
            <h2 className="text-2xl mt-1">Hesabınıza giriş yapın</h2>
          </div>
          <div className="space-y-3">
            <div>
              <Label>E-posta</Label>
              <Input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div>
              <Label>Şifre</Label>
              <Input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
          </div>
          <Button data-testid="login-submit-button" type="submit" disabled={loading} className="w-full bg-zinc-900 hover:bg-zinc-800">
            {loading ? "Giriş yapılıyor..." : "Giriş yap"}
          </Button>
          <p className="text-xs text-zinc-400 text-center">
            Yeni hesap için lütfen yöneticinizle iletişime geçin.
          </p>
        </form>
      </div>
    </div>
  );
}
